export default __webpack_public_path__ + "img/f4969e93e591b3cce29edef32a69a772.png";